import { useEffect, useState } from 'react'
import SectionForm, { getFormField, useFormContext } from "../SectionForm"
import { useBienContext } from "../BienContext"

const FieldList = [
  // Partie 1
  {name: "cuisine", label: "Cuisine"},
  {name: "climatisation", label: "Climatisation"},
  {name: "chauffage", label: "Chauffage"},
  {name: "ascenseur", label: "Ascenseur"},
  {name: "menuiserie", label: "Menuiserie"},
  // Partie 2
  {name: "eau_chaude", label: "Eau chaude"},
  {name: "eaux_usees", label: "Eaux usées"},
  {name: "internet", label: "Internet"},
  {name: "detecteur_fumee", label: "Détecteur de fumée", type: 'toggle'},
  // Partie 3
  {name: "ventilation", label: "Ventilation" },
  {name: "isolation", label: "Isolation"},
  { name: "autres_equipements", label: "Autres équipements", type: 'textarea',
    hint: "Exemple : alarme, accès PMR, interphone, vidéosurveillance, adoucisseur, domotique, etc."
  }
]

// typeBien est passé en props car SectionForm
// ne crée les values dans le form que pour les fields définis
const FormContent = ({fields, typeBien}) => {
  const { control } = useFormContext()
  return (
    <>
      <div className="flex flex-col items-center gap-4">                
        {fields.slice(0, (typeBien === 'immeuble' ? 4 : 5) ).map( 
          (field, index) => getFormField(control, field, index) 
        )}
      </div>
      <div className="flex flex-col items-center gap-4">                
        {fields.slice(
          (typeBien === 'immeuble' ? 4 : 5),
          (typeBien === 'immeuble' ? 8 : 9)
        ).map( (field, index) => getFormField(control, field, index) )
        }
      </div>
      <div className="flex flex-col items-center gap-4">                
        {fields.slice((typeBien === 'immeuble' ? 8 : 9)).map(
          (field, index) => getFormField(control, field, index)
        )}
      </div>
    </>
  )
}

const Form = ({ title = "", onClose = () => {}, onSuccess = () => {} }) => {
  const { bien } = useBienContext()
  const typeBien = bien.type_bien
  const [fields, setFields] = useState(FieldList)

  useEffect(
    () => {
      if(typeBien === 'immeuble') {
        setFields(FieldList.filter( f => f.name !== 'cuisine'))
      }
    },
    [typeBien]
  )

  return (
    <SectionForm
      title={title}
      onClose={onClose}
      onSuccess={onSuccess}
      fields={[...fields.map( f => f.name), "detecteur_fumee", "autres_equipements"]}
    >
      <FormContent fields={fields} typeBien={typeBien} />
    </SectionForm>
  )
}

export default Form